import { render, staticRenderFns } from "./Division.vue?vue&type=template&id=62a5d627&"
import script from "./Division.vue?vue&type=script&lang=js&"
export * from "./Division.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports